import { classNames, h } from "omi";

import { PortfolioStore } from "@/pages/portfolio/store";
import { NWAvatar, NWIcon, NWTooltip } from "@/components";
import { Store } from "@/store";

type Props = {
  align?: "center" | "left";
};
export function AvatarSection({ align = "center" }: Props) {
  const isViewing = !PortfolioStore.isEditable() && PortfolioStore.viewing.value;
  const ownerInfo = PortfolioStore.getOwnerInfo();

  const showCloseViewingButton = isViewing && !!ownerInfo && Store.user.isLoggedIn.value;

  const handleStopViewing = () => {
    PortfolioStore.stopViewingOtherPortfolio();
  };

  // TODO the following may change based on Jon's new designs
  // only show nw logo if anon viewing their own portfolio
  // As anon viewing someone else's portfolio, nw logo will show as the user avatar.
  return (
    <div
      className={classNames("flex items-center", {
        "justify-start": align === "left",
        "justify-center": align === "center",
      })}
    >
      <div className="w-12 z-[1] h-12 shrink-0 bg-gray-200 rounded-lg -rotate-6 flex items-center justify-center">
        <NWAvatar withIndicator={false} shape="square" size="lg" />
      </div>

      {Store.features.hasFeature("app.portfolio") && isViewing && !!ownerInfo ? (
        <NWTooltip
          delay={[0, 100]}
          content={`Viewing ${ownerInfo.name}'s portfolio`}
          placement="top"
          maxWidth="320px"
          className={classNames({
            "z-[2]": !!ownerInfo,
          })}
        >
          <div
            className={classNames(
              "relative w-12 h-12 shrink-0 bg-black rounded-lg rotate-6 flex items-center justify-center",
            )}
          >
            <NWAvatar
              withIndicator={false}
              shape="square"
              size="lg"
              imgUrl={ownerInfo.profileImg}
              interactive={false}
              borderClass="border-2 border-leather"
            />
            {showCloseViewingButton && (
              <button
                className="absolute -top-2 -right-2 p-0.5 shrink-0 bg-error-400 hover:bg-error-600 transition-all hover:scale-110 rounded-full"
                onClick={handleStopViewing}
              >
                <NWIcon name="cross" width={12} height={12} className="text-white"></NWIcon>
              </button>
            )}
          </div>
        </NWTooltip>
      ) : (
        <div
          className={classNames(
            "relative w-12 h-12 shrink-0 bg-black rounded-lg rotate-6 flex items-center justify-center",
          )}
        >
          <NWIcon name="nextwork-white" className="text-white" width={24} height={24} />
        </div>
      )}
    </div>
  );
}
